import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import format from 'date-fns/format';

const PureTimeByCountryComponent = ({ children, countryCode = 'US', dateTime, time12hrFormat = 'h:mm aaaa', time24hrFormat = 'kk:mm' }) => {
  const standardTime = format(new Date(dateTime), time12hrFormat);
  const railwayTime = format(new Date(dateTime), time24hrFormat);
  const twelveHourCountries = ['AU', 'CA', 'NZ', 'PH', 'US']; //currently only Australia, Canada, New Zealand, the Phillipines, and the United States use 12-hr time.
  const isTwelveHour = twelveHourCountries.includes(countryCode);
  return (
    <time dateTime={ isTwelveHour ? standardTime : railwayTime }>
      { isTwelveHour ? standardTime : railwayTime }
      { children }
    </time>
  );
};

PureTimeByCountryComponent.propTypes = {
  children: PropTypes.string,
  countryCode: PropTypes.string,
  dateTime: PropTypes.string.isRequired,
  time12hrFormat: PropTypes.string,
  time24hrFormat: PropTypes.string
};

const TimeByCountryComponent = connect(
  state => ({
    countryCode: state.country,
  })
)(PureTimeByCountryComponent);

export default TimeByCountryComponent;
